export default __webpack_public_path__ + "ed77798a5127d866c502e373df8f58fc.png";